import React, { useState, useEffect } from 'react';
import {
	makeStyles,
	Button,
	Box,
	InputAdornment,
	Tabs,
	Tab,
	withStyles,
	FormControlLabel,
	Checkbox,
	Divider,
	Grid,
	MenuItem,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { TextField } from 'formik-material-ui';
import { Field, Form, Formik } from 'formik';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PhoneIcon from '@material-ui/icons/Phone';
import AccountCircle from '@material-ui/icons/AccountCircle';
// import BodyText from './BodyText';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
// import { loginDispatch } from '../reducers/UsersReducer';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import {
	agentedituserDispatch,
	travelleredituserDispatch,
} from '../../reducers/UserReducer';
import SuccessModal from './SuccessModal';
import ErrorModal from './ErrorModal';
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
			borderRadius: 12,
		},
		// backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 10,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 12,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: '#39c9bb',
		color: 'white',
		fontSize: 15,
		borderRadius: 25,
		width: '100%',
		padding: '18px 8px',
		'&:hover': {
			backgroundColor: '#39c9bb',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
}));
// const country = ['INDIA', 'SRILANKA'];
const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const country = ['Jharkhand', 'Kolkata'];

const MyProfileForm = () => {
	const classes = useStyles();
	// const theme = useTheme();
	const [tabvalue, setValue] = React.useState(0);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	const [check, setCheck] = useState(false);
	const handleCheck = (event) => {
		setCheck(event.target.checked);
	};
	const dispatch = useDispatch();
	const history = useHistory();
	const { travellerlogin, agentlogin } = useSelector((state) => state.user);
	const [currentStep, SetCurrentStep] = useState('Step 1');

	const handleFormSubmit = (data, actions) => {
		if (
			agentlogin &&
			agentlogin.result &&
			agentlogin.result.result &&
			agentlogin.result.result.role === 'Agent'
		) {
			let formData2 = {
				userId:
					agentlogin &&
					agentlogin.result &&
					agentlogin.result.result &&
					agentlogin.result.result.id,
				userFirstName: data.userFirstName,
				userLastName: data.userLastName,
				userPhoneCode: '91',
				userPhone: data.userPhone,
			};
			dispatch(agentedituserDispatch(formData2, history));
		} else {
			let formData = {
				userId:
					travellerlogin &&
					travellerlogin.result &&
					travellerlogin.result.result &&
					travellerlogin.result.result.id,
				userFirstName: data.userFirstName,
				userLastName: data.userLastName,
				userPhoneCode: '91',
				userPhone: data.userPhone,
			};
			dispatch(travelleredituserDispatch(formData, history));
		}

		// dispatch(loginDispatch(formData, actions, history, checked));
	};

	return (
		<>
			<Formik
				initialValues={{
					userFirstName: agentlogin
						? agentlogin &&
						  agentlogin.result &&
						  agentlogin.result.result &&
						  agentlogin.result.result.name.trimStart().split(' ')[0]
						: travellerlogin
						? travellerlogin &&
						  travellerlogin.result &&
						  travellerlogin.result.result &&
						  travellerlogin.result.result.name.trimStart().split(' ')[0]
						: '',
					userLastName: agentlogin
						? agentlogin &&
						  agentlogin.result &&
						  agentlogin.result.result &&
						  agentlogin.result.result.name.trimStart().split(' ')[1]
						: travellerlogin
						? travellerlogin &&
						  travellerlogin.result &&
						  travellerlogin.result.result &&
						  travellerlogin.result.result.name.trimStart().split(' ')[1]
						: '',
					userPhone: agentlogin
						? agentlogin &&
						  agentlogin.result &&
						  agentlogin.result.result &&
						  agentlogin.result.result.phone
						: travellerlogin
						? travellerlogin &&
						  travellerlogin.result &&
						  travellerlogin.result.result &&
						  travellerlogin.result.result.phone
						: '',
				}}
				validate={(values) => {
					const errors = {};

					// if (!values.email) {
					// 	errors.email = 'Required';
					// } else if (
					// 	!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
					// ) {
					// 	errors.email = 'Invalid email address';
					// }
					// if (!values.password) {
					// 	errors.password = 'Required';
					// }
					// if (!values.confirm_password) {
					// 	errors.confirm_password = 'Required';
					// } else if (values.confirm_password === values.password2) {
					// 	errors.confirm_password = 'Required';
					// }
					// if (!values.phone) {
					// 	errors.phone = 'Required';
					// }
					// if (!values.first_name) {
					// 	errors.first_name = 'Required';
					// }
					// if (!values.address) {
					// 	errors.address = 'Required';
					// }
					// if (!values.company_name) {
					// 	errors.company_name = 'Required';
					// }
					// if (!values.state) {
					// 	errors.state = 'Required';
					// }
					// if (!values.city) {
					// 	errors.city = 'Required';
					// }
					// if (!values.country) {
					// 	errors.country = 'Required';
					// }

					return errors;
				}}
				onSubmit={handleFormSubmit}>
				{({ submitForm, isSubmitting, values, errors }) => (
					<>
						{' '}
						<Box>
							<TitleText
								four
								textStyle={{ fontFamily: 'Josefin Sans, sans-serif' }}>
								Edit Profile
							</TitleText>
						</Box>
						<Form>
							<Grid
								container
								spacing={2}
								alignItems='center'
								style={{ marginTop: 20 }}>
								<Grid item xs={12} sm={6} md={4} lg={4}>
									<Field
										component={TextField}
										name='userFirstName'
										type='text'
										variant='outlined'
										label='First Name'
										// error={errors.first_name}
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={{
											style: { padding: 14, fontSize: 16 },
										}}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={4}>
									<Field
										component={TextField}
										name='userLastName'
										type='text'
										variant='outlined'
										label='Last Name'
										// error={errors.first_name}
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={{
											style: { padding: 14, fontSize: 16 },
										}}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={4}>
									<Field
										component={TextField}
										name='userPhone'
										type='text'
										variant='outlined'
										// error={errors.phone}
										label='Phone Number'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={{
											style: { padding: 14, fontSize: 16 },
										}}
									/>
								</Grid>
							</Grid>
							{/* <Grid
							container
							spacing={2}
							alignItems='center'
							style={{ marginTop: 20 }}>
							<Grid item xs={12} sm={6} md={4} lg={4}>
								<Field
									component={TextField}
									name='company_name'
									type='text'
									variant='outlined'
									label='Company Name'
									error={errors.company_name}
									className={classes.selectField}
									InputProps={{
										className: classes.InputPropsStyle,
									}}
									inputProps={{
										style: { padding: 20 },
									}}
								/>
							</Grid>
							<Grid item xs={12} sm={6} md={8} lg={8}>
								<Field
									component={TextField}
									name='address'
									type='text'
									variant='outlined'
									label='Street Address'
									error={errors.address}
									className={classes.selectField}
									InputProps={{
										className: classes.InputPropsStyle,
									}}
									inputProps={{
										style: { padding: 20 },
									}}
								/>
							</Grid>
						</Grid> */}
							{/* <Grid
							container
							spacing={2}
							alignItems='center'
							style={{ marginTop: 20 }}>
							<Grid item xs={12} sm={6} md={4} lg={4}>
								<Field
									component={TextField}
									select
									name='state'
									type='text'
									variant='outlined'
									label='State'
									className={classes.selectField}
									InputProps={{
										className: classes.InputPropsStyle,
									}}
									inputProps={{
										style: { padding: 20 },
									}}>
									{country.map((item, index) => (
										<MenuItem key={index} value={item}>
											{item}
										</MenuItem>
									))}
								</Field>
							</Grid>
							<Grid item xs={12} sm={6} md={4} lg={4}>
								<Field
									component={TextField}
									select
									name='city'
									type='text'
									variant='outlined'
									label='City'
									className={classes.selectField}
									InputProps={{
										className: classes.InputPropsStyle,
									}}
									inputProps={{
										style: { padding: 20 },
									}}>
									{country.map((item, index) => (
										<MenuItem key={index} value={item}>
											{item}
										</MenuItem>
									))}
								</Field>
							</Grid>
							<Grid item xs={12} sm={6} md={4} lg={4}>
								<Field
									component={TextField}
									select
									name='country'
									type='text'
									variant='outlined'
									label='Country'
									className={classes.selectField}
									InputProps={{
										className: classes.InputPropsStyle,
									}}
									inputProps={{
										style: { padding: 20 },
									}}>
									{country.map((item, index) => (
										<MenuItem key={index} value={item}>
											{item}
										</MenuItem>
									))}
								</Field>
							</Grid>
						</Grid> */}
							<Grid container style={{ marginTop: 20 }}>
								<Grid item xs={12} sm={6} md={4} lg={4}>
									<Button
										className={classes.createButton}
										onClick={submitForm}
										style={{ marginTop: 5 }}
										// disabled={isSubmitting}
									>
										UPDATE
									</Button>
								</Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
			<SuccessModal />
			<ErrorModal />
		</>
	);
};

export default MyProfileForm;
